module.exports = __webpack_public_path__ + "static/media/save.d5a69113.svg";